import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto py-10 px-4 text-gray-700">
      <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>
      <p className="mb-4">
        LEARNERS RIDERrespect your privacy and are committed to protecting your personal information. This Privacy Policy explains how LEARNERS RIDERcollect, use, and safeguard your data when you register for our courses via our website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Information LEARNERS RIDERCollect</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Full Name</li>
        <li>Email Address</li>
        <li>Contact Number</li>
        <li>Education Qualification</li>
        <li>Preferred Language</li>
        <li>Selected Course Duration</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. How LEARNERS RIDERUse Your Information</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>To register you for the selected course.</li>
        <li>To communicate course-related updates and instructions.</li>
        <li>To process your payments securely.</li>
        <li>To enhance your learning experience and provide support.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Data Protection & Security</h2>
      <p className="mb-4">
        LEARNERS RIDERimplement appropriate technical and organizational measures to protect your personal data against unauthorized access, misuse, or disclosure.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Payment Security</h2>
      <p className="mb-4">
        All payments are processed securely through trusted payment gateways. LEARNERS RIDERdo not store or have access to your payment details like UPI PINs or bank passwords.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Third-Party Services</h2>
      <p className="mb-4">
        LEARNERS RIDERmay use third-party services (like payment gateways) to facilitate payments or other functionalities. These services are bound by their respective privacy policies.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Your Rights</h2>
      <p className="mb-4">
        You have the right to access, modify, or delete your personal information at any time by contacting us.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Changes to This Policy</h2>
      <p className="mb-4">
        LEARNERS RIDERmay update this Privacy Policy periodically. Changes will be posted on this page with a revised effective date.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Contact Us</h2>
      <p className="mb-4">
        If you have any questions or concerns regarding this Privacy Policy, please contact us at:
      </p>
      <p className="mb-4 font-medium">📧 Email: learnersrider@gmail.com</p>
      <p className="mb-4 font-medium">📧 Contact: 9495083895</p>

      <p className="text-sm text-gray-500 mt-6">Last updated: July 2025</p>
    </div>
  );
};

export default PrivacyPolicy;
